// src/context/ChatContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';

const ChatContext = createContext();

function normalizeChatRecipient(user) {
  if (!user) return null;

  const accountUser = user.user && typeof user.user === 'object' ? user.user : null;
  const recipientId = user.user_id || accountUser?.id || user.id || null;

  if (!recipientId) return null;

  return {
    ...accountUser,
    ...user,
    id: recipientId,
    user_id: recipientId,
    first_name: user.first_name || accountUser?.first_name || '',
    last_name: user.last_name || accountUser?.last_name || '',
    username: user.username || accountUser?.username || '',
    email: user.email || accountUser?.email || '',
    role: user.role || accountUser?.role || '',
    primary_profile_image:
      user.primary_profile_image ||
      accountUser?.primary_profile_image ||
      null,
    profile_images:
      user.profile_images ||
      accountUser?.profile_images ||
      [],
  };
}

export function ChatProvider({ children }) {
  const [chatDrawerOpen, setChatDrawerOpen] = useState(false);
  const [chatRecipient, setChatRecipient] = useState(null);

  const launchChat = (user) => {
    const normalizedRecipient = normalizeChatRecipient(user);
    if (!normalizedRecipient?.id) return false;
    setChatRecipient(normalizedRecipient);
    setChatDrawerOpen(true);
    return true;
  };

  const value = useMemo(() => ({
    chatDrawerOpen,
    setChatDrawerOpen,
    chatRecipient,
    setChatRecipient,
    launchChat,
  }), [chatDrawerOpen, chatRecipient]);

  return (
    <ChatContext.Provider value={value}>
      {children}
    </ChatContext.Provider>
  );
}


export const useChat = () => {
  return useContext(ChatContext);
};
